// Billing B3.0a. The site reads bookings from the one `bookings` record
// (B3.0), not from the copies on the user records.
// Plan: project files, billing/B3.0a-read-bookings-record-plan.md.
//
// firestore.rules lets a user read a booking only as its booker or its host,
// so each query must ask for the user's own ID, or Firestore refuses it.

import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '.';
import { COLLECTION } from '../helper/collections';
import { BOOKING_STATUS } from '../helper/booking-status';
import { pendingCents } from '../helper/price';

export const BOOKER = 'bookerId';
export const HOST = 'hostId';

/**
 * One record in the shape the booking pages show (the old copy's field names),
 * so the page layout code does not change. `isReserved`: the rest is due.
 */
export const toViewBooking = (id, record) => ({
  stripe_id: id,
  venue_id: record.venueId,
  start: record.start,
  end: record.end,
  startTime: record.startTime || null,
  endTime: record.endTime || null,
  amount: record.amount,
  totalPrice: record.totalPrice,
  payments: Array.isArray(record.payments) ? record.payments : [],
  bookedOn: record.bookedOn,
  cancelledOn: record.cancelledOn || false,
  customerName: record.customerName,
  customerEmail: record.customerEmail,
  typeBooking: record.typeBooking,
  isReserved: record.status === BOOKING_STATUS.RESERVED,
  // Billing B3.1: what the next payment charges (no late fee).
  pendingCents: record.status === BOOKING_STATUS.RESERVED ? pendingCents(record) : null
});

/** The user's bookings as booker (BOOKER) or as host (HOST), in the page shape. */
export const readBookings = async (field, uid) => {
  if (!uid) return [];
  const snap = await getDocs(query(collection(db, COLLECTION.BOOKINGS), where(field, '==', uid)));
  return snap.docs.map((doc) => toViewBooking(doc.id, doc.data()));
};

/** Newest event first. Dates are YYYY-MM-DD, so text order is date order. */
export const byStartNewestFirst = (a, b) => (a.booking.start < b.booking.start ? 1 : a.booking.start > b.booking.start ? -1 : 0);
